<template>
    <div class="navbar-brand">
        <div class="pl-2 pb-2"><img src="/img/askmygp-logo-white.png"></div>
        <div class="bg-primary p-2">
            <span v-text='$root.user ? $root.user.provider.name : ""'></span>
            <span v-text='isServiceAvailable() ? "" : "(Offline)"'></span>
        </div>
    </div>
</template>

<script>
export default {
    props: [
    ],
    data: function(){
        return {
        };
    },
    methods: {
    }
}
</script>
